import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getTrends } from "@/lib/apiClient";
import { Reveal } from "@/components/Reveal";

const ACCENT_BG = ["bg-cobalt text-white", "bg-brorange text-white", "bg-brlime text-ink", "bg-brpink text-white", "bg-bryellow text-ink", "bg-ink text-white"];

export default function Trends() {
  const [data, setData] = useState(null);
  useEffect(() => { window.scrollTo(0, 0); getTrends().then(setData); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="enter">
        <p className="eyebrow text-ink/60">Patterns in the evidence</p>
        <h1 className="font-display font-extrabold text-5xl sm:text-6xl display-tight uppercase mt-3">Trends</h1>
        <p className="text-ink/70 mt-4 max-w-2xl leading-relaxed">
          Trends here come only from patterns within the case-study database. When the evidence starts repeating,
          a trend appears. No predictions, no generic AI think-pieces — just what the cases show.
        </p>
      </div>

      {!data ? (
        <div className="grid md:grid-cols-2 gap-5 mt-10">
          {Array.from({ length: 6 }).map((_, i) => <div key={i} className="skeleton h-44 border-2 border-ink/10" />)}
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-5 mt-10">
          {data.trends.map((t, i) => (
            <Reveal key={t.title} delay={i * 70}>
              <div className={`border-2 border-ink p-6 h-full flex flex-col ${i < 2 ? ACCENT_BG[i] : "bg-white text-ink"}`}>
                <div className="flex items-start justify-between gap-4">
                  <h2 className="font-display font-extrabold text-2xl sm:text-3xl leading-[1.05] tracking-tight">{t.title}</h2>
                  <span className="font-display font-extrabold text-4xl tracking-tighter leading-none shrink-0">{t.count}</span>
                </div>
                <div className={`mt-4 flex flex-wrap gap-2 text-sm ${i < 2 ? "opacity-90" : "text-ink/70"}`}>
                  {t.breakdown.map((b) => (
                    <span key={b.label} className={`px-2 py-1 border ${i < 2 ? "border-white/40" : "border-ink/15 bg-secondary"}`}>{b.label} <strong>{b.count}</strong></span>
                  ))}
                </div>
                <div className="mt-auto pt-5 flex flex-wrap gap-x-3 gap-y-1 text-sm">
                  {t.examples.map((e, idx) => (
                    <Link key={e.slug} to={`/case/${e.slug}`} className={`group inline-flex items-center gap-1 font-semibold underline-offset-2 hover:underline ${i < 2 ? "" : "text-cobalt"}`}>
                      {e.company}{idx < t.examples.length - 1 ? "," : ""}
                    </Link>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
}
